import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class FarmersModel {
    @ApiProperty()
    farmerId: number;
    constructor(farmerId:number){
        this.farmerId = farmerId;
    }
}